import { http } from '@/plugins/http'
import DataResponse from '@/types/DataResponse'
import Setting from '@/types/Setting'
import { AxiosResponse } from 'axios'

export default class SettingService {
  index(): Promise<AxiosResponse<DataResponse<Setting[]>>> {
    return http.get<DataResponse<Setting[]>>(`/api/v1/office/settings`)
  }
}
